import { getApiClient } from '../api-client';
import { getData, getPagination } from '../api-response';
import { buildListQuery } from '../query';

const apiClient = getApiClient();

export type NotificationSeverity = 'info' | 'warning' | 'critical' | string;

export interface NotificationItem {
  id: string;
  userId?: string | null;
  roleScope?: string | null;
  type: string;
  severity: NotificationSeverity;
  title: string;
  message: string;
  link?: string | null;
  dedupeKey?: string | null;
  readAt?: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  items: NotificationItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export class NotificationsApiService {
  static async getNotifications(
    page = 1,
    limit = 20,
  ): Promise<NotificationsResponse> {
    const response = await apiClient.get(`/notifications${buildListQuery({ page, limit })}`);
    const data = getData(response);
    return {
      items: Array.isArray(data) ? data : [],
      pagination: getPagination(response)!,
    };
  }

  static async getUnreadCount(): Promise<{ count: number }> {
    const response = await apiClient.get('/notifications/unread-count');
    return getData(response);
  }

  static async markRead(id: string): Promise<NotificationItem> {
    const response = await apiClient.patch(`/notifications/${id}/read`);
    return getData(response);
  }

  static async markAllRead(): Promise<{ updated: number } | { message: string }> {
    const response = await apiClient.post('/notifications/read-all');
    return getData(response);
  }
}

export default NotificationsApiService;
